import { buildPanelItem } from "../helpers/buildPanelItem";
import { capturePanel } from "./capture";
import { scoresPanel } from "./scores";
import { imagePanel } from "./image";
import { Label } from "../components/Label";
import { Collapse } from "antd";

export const panel = [
  buildPanelItem(
    "1",
    Label({ label: "transaction_id", type: "string" }),
    "This is the identifier of the transaction that can later be used for queries in the panel as well as for auditing purposes.",
  ),
  buildPanelItem(
    "2",
    Label({ label: "environment", type: "string" }),
    'Environment can be either "sandbox" or "production" depending on capture key that is used.',
  ),
  buildPanelItem(
    "3",
    Label({ label: "type", type: "string" }),
    'A transaction can be of three different two types, namely "onboarding" and "verification". As the name says, "onboarding" transactions should be considered for the registration of users on the partner\'s workspace, provided the user passes the security checks and the transaction is considered low risk. On the other hand, "verification" transactions should be used for any sort of user authentication, specially as an additional authentication factor of sensitive transactions such as change of key user information (email, phone number, etc.), payments, transfers, e-commerce checkouts, acceptance of contracts, etc.',
  ),
  buildPanelItem(
    "4",
    Label({ label: "date", type: "string" }),
    "The date and time that the transaction was processed.",
  ),
  buildPanelItem(
    "5",
    Label({ label: "risk_level", type: "string" }),
    'The risk of the transaction. Possible values are "low", "high", and "unknown". Such values are established according to (i) the analysis of the device information and geolocation, (ii) the liveness check and (iii) the face matching results. If all three checks pass, transaction is "low" risk. If one such check fails, transaction is "high" risk. If the device check or the liveness check pass but there is no face to match, then transaction risk is "unknown".',
  ),
  buildPanelItem(
    "6",
    Label({ label: "end2end_id", type: "string" }),
    "This is an optional parameter that is meant to be an unique identifier. When informed by the partner, such an identifier passes through our service and is delivered to the partner via the webhook. It allows for a 1:1 mapping of the transaction between the frontend and the backend of the partner. Using it the right way -- by checking the 1:1 mapping of the transaction -- is strongly recommended for security reasons.",
  ),
  buildPanelItem(
    "7",
    Label({ label: "capture", type: "object" }),
    null,
    <Collapse items={capturePanel} />,
  ),
  buildPanelItem(
    "8",
    Label({ label: "scores", type: "object" }),
    null,
    <Collapse items={scoresPanel} />,
  ),
  buildPanelItem(
    "9",
    Label({ label: "image", type: "object" }),
    null,
    <Collapse items={imagePanel} />,
  ),
  buildPanelItem(
    "10",
    Label({ label: "user_identifier", type: "string" }),
    "The identifier of the user in the form of an email address or tax ID (e.g., CPF) as provided by the partner (via parameter) or by the user (via the capture component). This is a personal information that is sent to the partner via webhook and is not stored within our domain.",
  ),
];
